<button [class]="classes" [disabled]="disabled">
	<span><bp-icon *ngIf="leftIcon" [icon]="leftIcon" [size]="iconSize"></bp-icon></span>
	{{ title }}
	<ng-content></ng-content>
	<span><bp-icon *ngIf="rightIcon" [icon]="rightIcon" [size]="iconSize"></bp-icon></span>
</button>
